import cn from 'classnames';
import Checkbox from '@creditflowresearch/uilib/Checkbox';
import { AsyncSelect } from '@creditflowresearch/uilib/Select';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useLeadsSection from './useLeadsSection';
import { MIN_QUERY_LENGTH } from '@/creditflowresearch/application/BondScreener/constants';

import styles from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/checkboxFilter.module.scss';
import spaceStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

const Leads = () => {
  const {
    searchLeads,
    selectedOptions,
    handleChange,
    currentOptions,
    roles,
    hasLeadsSelected,
    isExcluded,
    onToggleExclude,
  } = useLeadsSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Leads }
      header={ (
        <FilterSectionHeader
          title="LEADS"
          rightSlot={ (
            <Checkbox
              label="Exclude selected"
              checked={ isExcluded }
              onChange={ onToggleExclude }
              dataTest="leadsExcludeCheckbox"
            />
          ) }
        />
      ) }
      dataTest="leadsSection"
    >
      <AsyncSelect
        isMulti
        name="leads"
        value={ selectedOptions }
        onChange={ handleChange }
        loadOptions={ searchLeads }
        filterOption={ () => true }
        defaultOptions={ currentOptions }
        placeholder="Select a Lead"
        dataTest="leadsSelect"
        noOptionsMessage={ () => 'No results' }
        hideSelectedOptions={ false }
        closeMenuOnSelect={ false }
        isNarrow
        useDebounce={ {
          minInputLength: MIN_QUERY_LENGTH.lead,
          timeout: 500,
          belowMinLengthMessage: `Search must contain at least ${ MIN_QUERY_LENGTH.lead } characters`,
        } }
      />
      <div className={ cn(styles.columns2, spaceStyles.mtl) }>
        { roles.items.map((item) => (
          <FilterItem key={ item.value } isExpandable={ false }>
            <Checkbox
              label={ item.name }
              checked={ roles.selectedValues.includes(item.value) }
              onChange={ () => roles.toggle(item.value) }
              disabled={ !hasLeadsSelected }
              dataTest={ `checkbox-leadRole-${ item.value }` }
            />
          </FilterItem>
        )) }
      </div>
    </FilterSection>
  );
};

export default Leads;
